import { notNull } from '~/_shared/utils/typeGuards';

export const parseImageUrlsFromValue = (cellValue: string | null | undefined): string[] => (
  cellValue ? cellValue.split(/[;\n]/).map(v => v.trim()).map(v => v === '' ? null : v).filter(notNull) : []
);
